import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import SpinnerLoader from "../../../pages/common/SpinnerLoader";
import {LabelWidget} from "../../index";
import {getFileUrl, useUploadFile} from "../../../utils/hooks/useUploadFile";
import {string2json} from "../../../utils/XUtils";
import {getAppMode} from "../../../ce/selectors/applicationSelectors";
import {useSelector} from "react-redux";
import {APP_MODE} from "../../../entities/App";
import {Overlay} from "@blueprintjs/core";
import {LeftOutlined, RightOutlined} from "../../../antdIcons";
import { ModalWrapper } from "@byk/pages/modeling/styled";

const ImagePickerWrapper = styled.div<{
  value: string;
  upBgColor: string;
  upIconColor: string;
  upBorderColor: string;
  loading: boolean;
  borderBottomWidth: number;
  borderRadius: string;
  previewSize:number;
}>`
  min-height: 32px;
  position: relative;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;

  .img-box {
    width: ${({previewSize})=> previewSize + 'px' || '100px'};
    height: ${({previewSize})=> previewSize + 'px' || '100px'};
    position: relative;
    border: ${({upBorderColor, borderBottomWidth})=> `${borderBottomWidth}px solid ${upBorderColor}` };
    border-radius: ${({borderRadius})=> borderRadius};
    .img-small {
      width: 100%;
      height: 100%;
      border-radius: ${({borderRadius})=> borderRadius};
    }

    .ip-delete-btn {
      width: 20px;
      height: 20px;
      display: none;
      position: absolute;
      z-index: 2;
      right: 5px;
      top: 5px;
      border-radius: 10px;
      background: rgba(0, 0, 0, .2);

      &:hover {
        cursor: pointer;
        background: rgba(0, 0, 0, .5);
      }

      &:after, &:before {
        content: '';
        position: absolute;
        background: #fff;
        width: 10px;
        height: 1px;
        left: 50%;
        top: 50%;
      }

      &:before {
        transform: translate3d(-50%, -50%, 0) rotate(-45deg);
      }

      &:after {
        transform: translate3d(-50%, -50%, 0) rotate(45deg);
      }
    }

    &:hover .ip-delete-btn {
      display: block;
    }
  }

  .file-box {
    position: relative;
    width: ${({previewSize})=> previewSize + 'px' || '100px'};
    height: ${({previewSize})=> previewSize + 'px' || '100px'};
    border: ${({upBorderColor, borderBottomWidth})=> `${borderBottomWidth}px solid ${upBorderColor}` };
    border-radius: ${({borderRadius})=> borderRadius};
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background-color: ${({upBgColor})=> upBgColor};
  }

  .file-box:after, .file-box:before {
    content: '';
    position: absolute;
    background: ${({upIconColor})=> upIconColor};
  }

  .file-box:before {
    left: 50%;
    top: 30%;
    bottom: 30%;
    width: 2px;
  }

  .file-box:after {
    left: 30%;
    right: 30%;
    top: 50%;
    height: 2px;
  }

  .ip-loading {
    display: ${({loading}) => loading ? 'block' : 'none'}
  }
  .file-mask{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.1);
  }

`;
const TImagePickerWidget = (props:any) => {
  const {value, updateMetaValue, color, fontSize, fontStyle, label,readonly,
    labelPosition,
    labelAlignment,
    isRequired,
    labelWidth,
    fileExt,
    fileCount,
    upIconColor,
    upBorderColor,
    upBgColor,
    borderBottomWidth,
    borderRadius,
    previewSize,
    defaultValue,
    isDisabled
  } = props;
  const {loading, uploadFile, removeFile, updateConfig, clearFiles} = useUploadFile();
  const [inputFile, setInputFile] = useState<string>();
  let count_value = value || defaultValue;
  let fileList:any = [];
  if(count_value?.startsWith('[{')){
    fileList = string2json(count_value, []);
  }else if (count_value && count_value!='[]' && !count_value.startsWith('[{')) {   // 兼容手机上传的图片在PC显示
    count_value.split(',').forEach((i:any)=>{
      fileList.push({'code':i ,'url':getFileUrl(i)});
    })
  }
  const appMode: ReturnType<typeof getAppMode> = useSelector(getAppMode);
  const isEditMode = appMode === APP_MODE.EDIT;
  const [isOpened, setIsOpened] = useState(false);
  const [imageIdx, setImageIdx] = useState(0);

  useEffect(() => {
    updateConfig({count: fileCount});
  }, [fileCount]);

  const onChange = (ev:any)=>{
    let file = ev.target.files[0];
    if(!file){ return ;}
    uploadFile({file}, (file:any)=>{
      fileList.push(file);
      updateMetaValue&&updateMetaValue(JSON.stringify(fileList));
      setInputFile('');
    })

  }
  const deleteImage = (idx:number)=>{
    removeFile(fileList[idx], () => {
      fileList.splice(idx, 1);
      updateMetaValue&&updateMetaValue(JSON.stringify(fileList));
    });
  }

  const switchPreview = (isNext:boolean = true) => {
    let idx = isNext ? imageIdx + 1 : imageIdx - 1;
    idx = (idx == fileList.length || idx == -1) ? imageIdx : idx;
    setImageIdx(idx);
  }
  useEffect(()=>{
    if(!value||value==='[]'){
      clearFiles();
    }
  }, [value])

  return (
    <>
      <LabelWidget
        label={label}
        fontSize={fontSize}
        color={color}
        fontStyle={fontStyle}
        labelAlignment={labelAlignment}
        labelPosition={labelPosition}
        required={isRequired}
        labelWidth={labelWidth}
      >

        <ImagePickerWrapper
          loading={loading}
          value={value}
          upBgColor={upBgColor}
          upIconColor={upIconColor}
          upBorderColor={upBorderColor}
          borderBottomWidth={borderBottomWidth}
          borderRadius={borderRadius}
          previewSize={previewSize}
        >

          {
            fileList.map((i:any, idx:number)=>{
              return (
                <div className="img-box" key={i}>
                  {!readonly &&
                    <div onClick={(e)=>{
                        e.stopPropagation();
                        e.preventDefault();
                        deleteImage(idx);
                      }}
                      className="ip-delete-btn"
                    />
                  }
                  <img className="img-small" src={i.url} alt=""  onClick={() => {
                    setIsOpened(true);
                    setImageIdx(idx);
                  }}/>
                </div>
              )
            })
          }

          {
            // fix: 6986 【SIT移动端】上传图片组件设置为只读后，在预览时显示为了一块灰色的方块
            // [期望]: 预览时不显示灰色方块
            (isEditMode || (!isEditMode && !readonly)) && fileList.length < fileCount &&
            <div className="file-box" style={{
              display: fileCount <= fileList.length?'none':'flex'
            }}>
              <input value={inputFile} style={{
                width: '100px',
                height:'100px',
                position: 'absolute',
                left: 0,
                top: 0,
                opacity: 0,
                display: isDisabled?'none':'block'
              }} type="file" accept={fileExt} onChange={onChange} />
              {
                loading && <SpinnerLoader className='ip-loading' size="lg" />
              }
              {
                readonly && <div className="file-mask"/>
              }
            </div>
          }

        </ImagePickerWrapper>
      </LabelWidget>

      <ModalWrapper  open={isOpened} footer={null} onCancel={() => setIsOpened(false)}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          {fileList.length > 1 &&
            <LeftOutlined disabled={imageIdx == 0} onClick={() => switchPreview(false)}/>
          }
          <img alt="example" style={{ width: '100%' }} src={fileList[imageIdx]?.url} />
          {fileList.length > 1 &&
            <RightOutlined disabled={imageIdx == fileList.length - 1} onClick={() => switchPreview(true)}/>
          }
        </div>
      </ModalWrapper>
    </>
  );
};

export default TImagePickerWidget;

